import { DashboardRoutes } from "@/router";
import { FiBriefcase, FiCpu, FiGrid, FiHome, FiPieChart } from "@payping/icons";
import { overviewTourIds } from "@/assets/tourIds";
import {
  navConnectionsId,
  navDigitalAccountId,
  navOverviewId,
  navSaleId,
  navSettlementId,
  navShopId,
} from "@/assets/googleTrackIds";
import { usePermission } from "@/utils/usePermission";
import { permissionsList } from "@/router/types";
import { useAppTranslation } from "@/utils";

export const useItems = () => {
  const { t } = useAppTranslation();
  const isSettlementGranted = usePermission([permissionsList.settlementOverview]);
  const isDigitalAccountGranted = usePermission([permissionsList.digitalAccountRoot]);
  const iconProps = { strokeWidth: 1.5 };

  const tabPanes = [
    {
      key: DashboardRoutes.home.root.url,
      title: t("mainNav.tabs.overview"),
      Icon: (props: any) => <FiHome {...props} {...iconProps} />,
      "data-tourId": overviewTourIds.overviewTab,
      "data-google-track": navOverviewId,
    },
    {
      key: DashboardRoutes.mySale.root.url,
      title: t("mainNav.tabs.sale"),
      Icon: (props: any) => <FiPieChart {...props} {...iconProps} />,
      "data-tourId": overviewTourIds.saleTab,
      "data-google-track": navSaleId,
    },
    {
      key: DashboardRoutes.myShop.root.url,
      title: t("mainNav.tabs.solutions"),
      Icon: (props: any) => <FiGrid {...props} {...iconProps} />,
      "data-tourId": overviewTourIds.shopTab,
      "data-google-track": navShopId,
    },
    {
      key: DashboardRoutes.connections.root.url,
      title: <span data-tourId={overviewTourIds.connectionTab}>{t("mainNav.tabs.connection")}</span>,
      Icon: (props: any) => <FiCpu {...props} {...iconProps} />,
      "data-tourId": overviewTourIds.connectionTab,
      "data-google-track": navConnectionsId,
    },
    ...(isSettlementGranted
      ? [
          {
            key: DashboardRoutes.settlement.root.url,
            title: t("mainNav.tabs.settlement"),
            Icon: (props: any) => <FiBriefcase {...props} {...iconProps} />,
            "data-google-track": navSettlementId,
          },
        ]
      : []),
    ...(isDigitalAccountGranted
      ? [
          {
            key: DashboardRoutes.digitalAccount.root.url,
            title: t("mainNav.tabs.digitalAccount"),
            Icon: (props: any) => <FiBriefcase {...props} {...iconProps} />,
            "data-google-track": navDigitalAccountId,
          },
        ]
      : []),
  ];

  return tabPanes;
};
